export default __webpack_public_path__ + "static/media/Bezel_Navy_Blue.d3db2f7f.png";